import './BubblesBackground.scss';
import Bubbles0 from 'assets/icons/bubbles/Bubbles-0.svg?react';
import Bubbles1 from 'assets/icons/bubbles/Bubbles-1.svg?react';
import Bubbles2 from 'assets/icons/bubbles/Bubbles-2.svg?react';
import Bubbles3 from 'assets/icons/bubbles/Bubbles-3.svg?react';
import LeftBubblesIcon1 from 'assets/icons/CandidateInformationBubblesLeft.svg?react';
import RightBubblesIcon1 from 'assets/icons/CandidateInformationBubblesRight.svg?react';
import { FunctionComponent, ReactNode } from 'react';

interface IBubblesBackground {
  className?: string;
  index?: number;
  children: ReactNode;
}

const BubblesBackground: FunctionComponent<IBubblesBackground> = ({
  children,
  className,
  index = 0,
}) => {
  let BubblesIcon;

  switch (index) {
    case 1:
      BubblesIcon = Bubbles1;
      break;
    case 2:
      BubblesIcon = Bubbles2;
      break;
    case 3:
      BubblesIcon = Bubbles3;
      break;
    case 4:
      BubblesIcon = ({ className }: { className: string }) => (
        <div className={className}>
          <LeftBubblesIcon1 />
          <RightBubblesIcon1 />
        </div>
      );
      break;
    default:
      BubblesIcon = Bubbles0;
  }

  return (
    <div className={`BubblesBackground${className ? ` ${className}` : ''}`}>
      <BubblesIcon className={`BubblesBackground__Bg--${index}`} />
      {children}
    </div>
  );
};

export default BubblesBackground;
